import React from "react";
import { ReactLenis } from "lenis/react";

export const SmoothScroll = ({ children }) => (
  <ReactLenis root options={{ lerp: 0.09, duration: 1.2, smoothWheel: true }}>
    {children}
  </ReactLenis>
);
